/** * @description 新增考勤组/详情 * @author daxiong */
<template>
  <div id="groupAdd">
    <van-cell
      title="参与考勤人员"
      is-link
      :value="isSetParticipants ? '已设置' : '未设置'"
      @click="participantsShow = true"
    />
    <van-field
      v-model="condition.groupName"
      label="考勤组名称"
      placeholder="请输入"
      input-align="right"
    />
    <van-cell
      title="考勤时间"
      is-link
      :value="isSetPunchCardTimeVos ? '已设置' : '未设置'"
      @click="attendanceTimeShow = true"
    />
    <van-cell
      title="打卡地点"
      is-link
      :value="isSetPunchCardPlaceVos ? '已设置' : '未设置'"
      @click="clockAddressShow = true"
    />
    <van-cell
      title="上班打卡后多久可打下班卡"
      @click="spaceTimeShow = true"
      is-link
      :value="setSpaceTime || '未设置'"
    />

    <div class="confirm-btn">
      <van-button
        v-if="!$route.path.includes('/lishui/groupEditor')"
        type="info"
        class="confirm"
        @click="addGroup"
        >新增考勤组</van-button
      >
      <template v-else>
        <van-button type="default" class="confirm" @click="addGroup('save')"
          >保存更改</van-button
        >
        <van-button type="danger" class="confirm" @click="deleteGroup"
          >删除考勤组</van-button
        >
      </template>
    </div>

    <!-- 参与人员 -->
    <van-popup v-model="participantsShow" position="right" class="max-popup">
      <participants
        @closePopupByParticipants="closePopupByParticipants"
      ></participants>
    </van-popup>

    <!-- 设置时间 -->
    <van-popup v-model="attendanceTimeShow" position="right" class="max-popup">
      <attendanceTime
        @closePopupByTime="closePopupByTime"
        :echoParam="condition"
      ></attendanceTime>
    </van-popup>

    <!-- 打卡地址 -->
    <van-popup v-model="clockAddressShow" position="right" class="max-popup">
      <clockAddress
        @closePopupByAddress="closePopupByAddress"
        :echoParam="condition"
      ></clockAddress>
    </van-popup>

    <!-- 上班打卡后多久可打下班卡 -->
    <van-popup v-model="spaceTimeShow" position="bottom">
      <van-picker
        title="打卡间隔"
        show-toolbar
        :columns="clockSpaceTimeColumns"
        @confirm="onSpaceTimeConfirm"
        @cancel="onSpaceTimeCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  getGroupDetailById,
  deleteGroupById,
  updateOrInsertGroup,
  checkDeleteStatus
} from '@api/lishui'
import { getLocalStorage } from '@utils'
import attendanceTime from './attendanceTime'
import clockAddress from './clockAddress'
import participants from './components/participants'
import { Dialog, Toast } from 'vant'
export default {
  components: { attendanceTime, clockAddress, participants },
  data() {
    return {
      userInfo: JSON.parse(getLocalStorage('lishuiUserInfo'))
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      attendanceTimeShow: false,
      spaceTimeShow: false,
      clockAddressShow: false,
      participantsShow: false,
      condition: {
        groupName: '', // 考勤组名
        punchCardTimeVos: {
          punchCardBeginTime: '', // 打卡开始时间
          punchCardEndTime: '', // 打开终止时间
          sort: '' // 规则内第几次上下班
        },
        punchCardStaffVos: [],
        punchCardPlaceVos: {
          placeName: '', // 打卡地点
          lat: '', // 纬度
          lng: '', // 经度
          range: '' // 打卡范围
        },
        creditCode: '', // 统代
        weekTime: '', // 每周打卡的时间
        restStatus: 0, // 是否休息 如果是2次打卡 则弹出该状态 1为弹出 0为不弹出
        restStartTime: '', // 休息开始时间
        restEndTime: '', // 休息结束时间
        spaceTime: '', // 间隔打卡时间，防止连续打卡
        punchNumber: '', // 设置打卡次数
        staffName: '' // 创建者
      },
      clockSpaceTimeColumns: [
        // 打卡间隔时间列表
        {
          values: [
            '0小时',
            '1小时',
            '2小时',
            '3小时',
            '4小时',
            '5小时',
            '6小时',
            '7小时',
            '8小时'
          ],
          defaultIndex: 0
        },
        {
          values: [
            '0分钟',
            '1分钟',
            '5分钟',
            '10分钟',
            '20分钟',
            '30分钟',
            '40分钟',
            '50分钟'
          ],
          defaultIndex: 1
        }
      ],
      setSpaceTime: ''
    }
  },
  computed: {
    // 是否选择参与人员
    isSetParticipants() {

      return (
        this.$store.state.clock.groupParticipants &&
        this.$store.state.clock.groupParticipants.length > 0
      )
    },
    // 是否设置考勤时间
    isSetPunchCardTimeVos() {
      return (
        this.condition.punchCardTimeVos &&
        this.condition.punchCardTimeVos.length > 0
      )
    },
    // 是否设置打卡地点
    isSetPunchCardPlaceVos() {
      return (
        this.condition.punchCardPlaceVos.length > 0
      )
    }
  },
  watch: {},
  methods: {
    /**
     * @description 新增
     */
    addGroup(val) {
      let msg = val ? '保存' : '新增'
      // this.condition.punchCardStaffVos = this.$store.state.clock.groupParticipants
      this.condition.creditCode = this.userInfo.creditCode
      this.condition.staffName = this.userInfo.staffName
      let ls = this.condition
      if (ls.punchCardStaffVos) {
        if (ls.punchCardStaffVos.length <= 0) {
          this.$notify({
            type: 'success',
            message: '请选择考勤人员'
          })
          return
        }
      }
      if (ls.groupName === '') {
        this.$notify({
          type: 'success',
          message: '请输入考勤组名称'
        })
        return
      } else if (ls.punchNumber === '') {
        this.$notify({
          type: 'success',
          message: '请设置打卡时间'
        })
        return
      } else if (ls.punchCardPlaceVos.lat === '') {
        this.$notify({
          type: 'success',
          message: '请选择打卡地点'
        })
        return
      }
      // console.log(this.condition.punchCardTimeVos)
      // console.log(this.condition.punchCardTimeVos.length)

      if (this.condition.punchCardTimeVos.length > 0) {
        this.condition.punchCardTimeVos.map((value, index) => {
          // console.log(value.punchCardBeginTime)
          if (value.punchCardBeginTime === '') {
            this.condition.punchCardTimeVos.splice(index, 1)
          }
        })
      }
      // console.log(this.condition.punchCardTimeVos)
      this.condition.punchCardTimeVos.map(value => {
        value.extraWork = value.extraWork ? 1 : 0
      })
      updateOrInsertGroup(this.condition).then(response => {
        let res = response.data
        if (res.code == '0000') {
          this.$notify({
            type: 'success',
            message: res.msg || msg + '成功'
          })
          setTimeout(() => {
            this.$router.go(-1)
          }, 500)
        } else {
          // Toast(res.msg);
          this.$notify({
            type: 'danger',
            message: res.msg || msg + '失败'
          })
        }
      })
    },

    /**
     * @description 删除
     */
    deleteGroup() {
      checkDeleteStatus({ id: this.$route.query.id }).then(res => {
        if (res.data.code === '0000') {
          if (res.data.data === 0) {
            this.deleteGroupById(this.$route.query.id)
          } else {
            Dialog.confirm({
              title: '',
              message: '今日已有人打卡，删除考勤组\n将同时删除今天考勤记录',
              className: 'dialog-content'
            })
              .then(() => {
                // on confirm
                this.deleteGroupById(this.$route.query.id)
              })
              .catch(() => {
                // on cancel
              })
          }
        }
      })
      // if (this.$route.path.includes('/lishui/groupEditor') && Object.keys(this.$route.query).includes('id')) {
      //     this.deleteGroupById(this.$route.query.id)
      // }
    },

    /**
     * @description 关闭设置时间弹窗
     */
    closePopupByTime(params) {
      this.condition = { ...this.condition, ...params }
      this.attendanceTimeShow = false
    },

    /**
     * @description 关闭地址弹窗
     */
    closePopupByAddress(param) {
      // debugger
      this.clockAddressShow = false
      this.condition = { ...this.condition, ...param }
    },

    /**
     * @description 关闭参与人员弹窗
     */
    closePopupByParticipants(param) {
      this.participantsShow = false
      // debugger
      if (param) {
        let arr = param.map(v => {
          return {
            mobile: v.mobile,
            staffName: v.staffName
          }
        })
        this.condition.punchCardStaffVos = arr
      }
    },

    /**
     * @description 查询考勤组详情通过id
     */
    getGroupDetailById(id) {
      getGroupDetailById({ id }).then(response => {
        let res = response.data
        if (res.code == '0000') {
          this.condition = res.data ? { ...this.condition, ...res.data } : {}
          if (res.data.spaceTime) {
            let time = `${res.data.spaceTime.split(':')[0]}小时${
              res.data.spaceTime.split(':')[1]
            }分钟`
            this.setSpaceTime = time
          } else {
            this.setSpaceTime = '不限'
          }
          this.$store.commit(
            'clock/setGroupParticipants',
            this.condition.punchCardStaffVos
          )
        }
      })
    },

    /**
     * @description 删除考勤组通过id
     */
    deleteGroupById(id) {
      deleteGroupById({ id }).then(response => {
        let res = response.data
        if (res.code == '0000') {
          this.$notify({
            type: 'success',
            message: res.msg
          })
          setTimeout(() => {
            this.$router.push({ name: 'punchClockRecords' })
          }, 500)
        }
      })
    },

    onSpaceTimeConfirm(val) {
      let spaceTime = ''
      // if (val[0].includes("0") && val[1].includes("0")) {
      //   this.condition.spaceTime = "";
      //   this.setSpaceTime = "不限1111";
      // } else {
      this.setSpaceTime = val
      spaceTime = `${val[0].split('小时')[0]}:${val[1].split('分钟')[0]}`

      // }
      this.condition.spaceTime = spaceTime
      this.spaceTimeShow = false
    },
    onSpaceTimeCancel() {
      this.spaceTimeShow = false
    }
  },
  destroyed() {
    this.$store.commit('clock/setGroupParticipants', [])
  },
  created() {
    if (
      this.$route.path.includes('/lishui/groupEditor') &&
      Object.keys(this.$route.query).includes('id')
    ) {
      this.getGroupDetailById(this.$route.query.id)
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
#groupAdd {
  height: 100%;
  font-size: 14px;
  padding-top: 8px;
  box-sizing: border-box;
  .max-popup {
    width: 100%;
    height: 100%;
  }
  ::v-deep .van-cell {
    box-sizing: border-box;
    &__title {
      box-sizing: border-box;
      color: #333;
      min-width: 50%;
    }
    &__value {
      min-width: 45%;
    }
  }
  .confirm-btn {
    box-sizing: border-box;
    width: 100%;
    min-height: 60px;
    background: #fff;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    align-items: center;
    padding: 10px;
    .confirm {
      width: 100%;
      height: 40px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
